import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-blueDownArrow",
  "use": "icon-blueDownArrow-usage",
  "viewBox": "0 0 8 5",
  "content": "<symbol viewBox=\"0 0 8 5\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-blueDownArrow\">\n<path d=\"M8 0H0L4 5L8 0Z\" fill=\"#597DF9\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol